import React, {ReactElement} from 'react';
import NumberFormat from 'react-number-format';

interface PhoneFormatProps {
  value?: string | number;
  displayType?: any;
  format?: string;
}

const PhoneFormatter = (props: PhoneFormatProps): ReactElement => {
  const {format, displayType, value} = props;
  return (
    <NumberFormat
      value={value}
      displayType={displayType || 'text'}
      format={format || '+# (###) ###-####'}
    />
  );
};

export default PhoneFormatter;
